export const LINKS = {
    facebook: "https://www.facebook.com/przystanczorsztynianka",
    instagram: "https://www.instagram.com/czorsztynianka/",
    codify: "https://codifystudio.pl/",

    phone: "tel:+48509438985",
    email: "mailto:biuro@zalewczorsztynski.com",

    mapsCzorsztyn: "https://maps.app.goo.gl/vbb4muGnBGXNeTh29",
    tourCzorsztyn: "https://tour.panoee.net/czorsztynianka-przystan-w-czorsztynie",

    mapsNiedzica: "https://maps.app.goo.gl/FuhZFBqRTVSLS9eT6",
    tourNiedzica: "https://tour.panoee.net/czorsztynianka-przystan-w-niedzicy",

    googleMapFrame:
        "https://www.google.com/maps/d/u/0/embed?mid=1MSsHZcFj2lej3zLBJaKp4IMEOSX9vps&ehbc=2E312F&noprof=1",

    bikesRentalMaps: "https://maps.app.goo.gl/eg1zaYx7ESMogBsj6",
    bikesRentalPhone: "tel:+48570631403",
    bikesRentalEmail: "mailto:velo@zalewczorsztynski.com",

    housesPhone: "tel:+48509923730",
    housesBooking: "https://www.booking.com/hotel/pl/zamkowe-wzgorze.pl.html",
    housesRulesPdf: "https://zalewczorsztynski.com/docs/domki-regulamin.pdf",
    housesMaps: "https://maps.app.goo.gl/HRPCRyEyQMwYhMgv5",
};